<template>
  <div class="userInfo">
    <el-form ref="form" action="" :model="form" label-width="250px" width="1000px">
        <el-form-item label="NickName">
            <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="Giới tính">
            <el-radio-group v-model="form.sex">
                <el-radio label="Nam"></el-radio>
                <el-radio label="Nữ"></el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="Ngày sinh">
            <el-date-picker type="date" placeholder="Chọn ngày" v-model="form.date" style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="Địa chỉ">
            <el-input v-model="form.adress"></el-input>
        </el-form-item>
        <el-form-item label="Số CMND/CCCD  *">
            <el-input v-model="form.idno"></el-input>
        </el-form-item>
        <el-form-item label="Nơi cấp CMND/CCCD">
            <el-input v-model="form.idnoFrom"></el-input>
        </el-form-item>
        <el-form-item label="Ngày cấp CMND/CCCD">
            <el-input v-model="form.idnoDate"></el-input>
        </el-form-item>
        <el-form-item label="Email *">
            <el-input v-model="form.email"></el-input>
        </el-form-item>
        <el-form-item label="Số điện thoại">
            <el-input v-model="form.phone"></el-input>
        </el-form-item>
        <el-form-item label="Ảnh đại diện">
            <el-upload
                class="upload-demo"
                ref="upload"
                list-type="picture"
                limit=1
                :on-change="handleChange"
                :on-remove="handleRemove"
                :file-list="form.fileList"
                :auto-upload="false">
                <el-button v-if="form.fileList.length===0" slot="trigger" size="small" type="primary">Chọn ảnh</el-button>
            </el-upload>
        </el-form-item>
        <el-form-item>
            <el-checkbox v-model="form.checked">Tôi đã đọc kỹ và hoàn toàn đồng ý với <a href="/Agreement.pdf" target="_blank">Thỏa Thuận Cung Cấp và Sử Dụng Dịch Vụ của Báo Hay 24h</a>. </el-checkbox>
        </el-form-item>

        <el-form-item>
            <el-button type="primary" @click="onSubmit">Submit</el-button>
        </el-form-item>
    </el-form>
  </div>
</template>
<script>
import Vue from 'vue';
import {Radio,RadioGroup,DatePicker,Upload,MessageBox,Message,Checkbox} from 'element-ui';
import * as cookies from "js-cookie";
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(DatePicker);
Vue.use(Upload);
Vue.use(Checkbox);
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$message = Message;
export default {
    data() {
      return {
        form: {
          name: cookies.get("fb_name"),
          checked:false,
          sex:"Nam",
          adress:"",
          idno: '',
          date: '',
          idnoFrom: "",
          idnoDate: "",
          email: "",
          phone: '',
          fileList:[]
        }
      }
    },
    methods: {
        handleChange(file){
            this.form.fileList.push(file)
        },
        handleRemove(){
            this.form.fileList=[]
        },
      onSubmit() {
          const that=this;
          if(this.form.idno=="" || this.form.email==''){
              this.$message({message:"Số CMND/CCCD and Email must input ",type: 'error'})
              return ;
          }
          if(!/^\d+$/.test(this.form.idno)){
              this.$message({message:"Số CMND/CCCD is error",type: 'error'})
              return ;
          }
          if(!/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.form.email)){
              this.$message({message:"Email address is error",type: 'error'})
              return ;
          }
          if(!this.form.checked){
              this.$message({message:"Vui lòng đọc Thỏa Thuận Cung Cấp và Sử Dụng Dịch Vụ của Báo Hay 24h",type: 'error'})
              return ;
          }
          const name=cookies.get("fb_name");
          window.localStorage.setItem(name,'1')
        this.$alert('Thông tin bạn nhập đã được bảo lưu thành công', 'Thông tin cập nhật thành công', {
          confirmButtonText: 'OK',
          callback: () => {
            that.$router.push({ path: "/" });
          }
        });
      }
    }
}
</script>
<style scoped>
.userInfo {
  display: block;
  position: relative;
  width: 1000px;
  margin: 0 auto;
  text-align: center;
  font-size: 24px;
  color: #f72442;
  padding: 45px 100px 32px 0;
}
form{
    text-align:left;
}
</style>




// WEBPACK FOOTER //
// UserInfoInput.vue?9f64a096